import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { catchError, tap, map, retry, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { User } from '../users/user.model';
import {
  HandleError,
  HttpErrorHandler,
} from '../modules/services/http-error-handler/http-error-handler.service';
import { Storage } from '@capacitor/storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authUserSubject = new BehaviorSubject<User>(null);
  isAuthUserLoaded = false;

  private readonly apiUrl = environment.apiUrl;
  private readonly serverUrl = environment.serverUrl;

  private authUserUrl = this.apiUrl + '/auth/me';
  private loginUrl = this.apiUrl + '/auth/login';
  private logoutUrl = this.apiUrl + '/auth/logout';
  private registerUrl = this.apiUrl + '/auth/register';
  // private removeTokenUrl = this.apiUrl + '/removeToken';

  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('AuthService');
  }

  // removeBackToken(email: string): Observable<any> {
  //   return this.http.post(this.removeTokenUrl+'/'+email, '').pipe(
  //     tap((data) => console.log(data)),
  //     catchError(this.handleError('removeBackToken', []))
  //   );
  // }

  getAuthUser(reload?: boolean): Observable<User> {
    if (this.isAuthUserLoaded && !reload) {
      console.log('already logged');
      return this.authUserSubject.asObservable();
    } else {
      console.log('fetch auth user from server');

      return this.http.get<User>(this.authUserUrl).pipe(
        map((data) => data['data']),
        tap((user: User) => {
          this.isAuthUserLoaded = true;
          this.authUserSubject.next(user);
        }),
        // retry(3),
        switchMap((data) => this.authUserSubject.asObservable())
        // catchError(this.handleError('getAuthUser', []))
      );
    }
  }

  login(userEmail: string, userPassword: string): Observable<any> {
    const request = {
      email: userEmail,
      password: userPassword
    };

    return this.http.post(this.loginUrl, request).pipe(
      map((response: User) => {
        // Receive  token in the response
        const token: string = response['token'];
        // If we have a token, proceed
        if (token) {
          this.setToken(token);
        }
        return response;
      }),
      retry(3),
      catchError(this.handleError('login', []))
    );
  }

  logout(): Observable<any> {
    return this.http.post(this.logoutUrl, {}).pipe(
      tap((data) => {
        this.removeToken();
        this.removeAuthUser();
      }),
      retry(3),
      catchError(this.handleError('logout', []))
    );
  }

  async isAuthenticated(): Promise<boolean> {
    const token: string = await this.getToken();

    if (token) {
      return true;
    }
    return false;
  }

  async setToken(token: string): Promise<void> {
    console.log('set token');
    console.log(token);
    await Storage.set({
      key: 'access_token',
      value: token,
    });
  }

  async getToken(): Promise<string> {
    const token = await Storage.get({ key: 'access_token' });
    return token.value;
  }

  async removeToken(): Promise<void> {
    console.log('remove token');
    await Storage.remove({
      key: 'access_token',
    });
  }

  removeAuthUser() {
    this.authUserSubject.next(null);
  }
}
